/**
 * Visitor analytics configuration.
 *
 * Paste ONE of the ids below to turn on tracking. Leave both blank to keep the site untracked.
 *
 * - googleAnalyticsId: a GA4 "Measurement ID" from analytics.google.com, looks like "G-XXXXXXXXXX".
 *   Use this if you just want Google Analytics.
 * - googleTagManagerId: a Google Tag Manager container id, looks like "GTM-XXXXXXX".
 *   Use this instead if you manage multiple tags (GA, ads pixels, etc.) through GTM.
 *
 * You can set one or both. Nothing is sent to Google until an id is filled in.
 */
export const analyticsConfig = {
  googleAnalyticsId: 'G-947DYPLW00' as string,
  googleTagManagerId: 'GTM-5B455RRZ' as string,
};
